import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsDirectory, CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const LineItemsBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { open } = useCommands();
    const {
        lineItemsSelectionLabel = "selected",
        lineItemsApplyClasses,
        lineItemsBulkAccrualCoaOptions,
        lineItemsBulkReceivablesOptions,
        lineItemsBulkPayablesOptions,
        onLineItemsBulkEdit,
        onLineItemsBulkCreateTask,
    } = options;

    return (
        <Command.Group heading={lineItemsSelectionLabel}>
            {lineItemsApplyClasses && (
                <CommandItem
                    keywords={["class", "classification"]}
                    shortcut="l"
                    onSelect={() =>
                        open(CommandsDirectory.LINE_ITEMS_BULK_CLASS, options)
                    }
                >
                    Set class
                </CommandItem>
            )}
            {lineItemsBulkAccrualCoaOptions &&
                lineItemsBulkAccrualCoaOptions.length > 0 && (
                    <CommandItem
                        keywords={["accrual", "ledger", "account"]}
                        shortcut="a"
                        onSelect={() =>
                            open(
                                CommandsDirectory.LINE_ITEMS_BULK_ACCRUAL_COA,
                                options,
                            )
                        }
                    >
                        Accrual ledger
                    </CommandItem>
                )}
            {lineItemsBulkReceivablesOptions &&
                lineItemsBulkReceivablesOptions.length > 0 && (
                    <CommandItem
                        keywords={["receivables", "accounts receivable", "ar"]}
                        onSelect={() =>
                            open(
                                CommandsDirectory.LINE_ITEMS_BULK_RECEIVABLES,
                                options,
                            )
                        }
                    >
                        Receivables account
                    </CommandItem>
                )}
            {lineItemsBulkPayablesOptions &&
                lineItemsBulkPayablesOptions.length > 0 && (
                    <CommandItem
                        keywords={["payables", "accounts payable", "ap"]}
                        onSelect={() =>
                            open(
                                CommandsDirectory.LINE_ITEMS_BULK_PAYABLES,
                                options,
                            )
                        }
                    >
                        Payables account
                    </CommandItem>
                )}
            {onLineItemsBulkEdit && (
                <CommandItem
                    keywords={["edit", "modify"]}
                    onSelect={onLineItemsBulkEdit}
                >
                    Edit
                </CommandItem>
            )}
            {onLineItemsBulkCreateTask && (
                <CommandItem
                    keywords={["task", "create"]}
                    onSelect={onLineItemsBulkCreateTask}
                    shortcut="t"
                >
                    Create task
                </CommandItem>
            )}
        </Command.Group>
    );
};
